import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import momentLocalizer from 'react-widgets-moment';
import adicionarFiltroCteOs from '../../actions/cteos/adicionarFiltroCteOs';
import removerFiltroCteOs from '../../actions/cteos/removerFiltroCteOs';
import FiltroBusca from '../comum/FiltroBusca'
import 'react-widgets/dist/css/react-widgets.css';

momentLocalizer();

export class FiltroBuscaCteOs extends Component {
  render () {
    if (!this.props.filtrosAdicionados) {
      return <div>Carregando...</div>
    }
    return (
      <FiltroBusca
        filtrosAdicionados={this.props.filtrosAdicionados}
        filtro={this.props.filtro}
        opcoes={this.props.opcoes}
        isNome={this.props.isNome}
        isRadio={this.props.isRadio}
        isNumero={this.props.isNumero}
        isPorcentagem={this.props.isPorcentagem}
        isValorMonetario={this.props.isValorMonetario}
        isFiltroData={this.props.isFiltroData}
        isFiltroHora={this.props.isFiltroHora}
        adicionarFiltro={this.props.adicionarFiltroCteOs}
        removerFiltro={this.props.removerFiltroCteOs}
      />
    )
  }
}

export const mapStateToProps = state => ({
  filtrosAdicionados: state.filtrosAdicionadosCteOs
})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltroCteOs,
    removerFiltroCteOs,
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroBuscaCteOs)
